import { CheckoutTabs } from 'constants/tabs';
import { StripePaymentMethod, StripePaymentMethodType } from 'generated/graphql';
import { Nullable } from 'interfaces';

export type State = {
  formLoading: boolean;
  addCardLoading: boolean;
  expanded: CheckoutTabs;
  loadStripeForm: boolean;
  selectedCard: Nullable<StripePaymentMethod>;
  paymentType: StripePaymentMethodType;
};

export const initialState: State = {
  formLoading: false,
  addCardLoading: false,
  expanded: CheckoutTabs.EXISTING,
  loadStripeForm: false,
  selectedCard: null,
  paymentType: StripePaymentMethodType.Card,
};

export enum ActionType {
  SET_FORM_LOADING = 'setFormLoading',
  SET_ADD_CARD_LOADING = 'setAddCardLoading',
  SET_EXPANDED = 'setExpanded',
  SET_LOAD_STRIPE_FORM = 'setLoadStripeForm',
  SET_SELECTED_CARD = 'setSelectedCard',
  SET_PAYMENT_TYPE = 'setPaymentType',
}

export type Action =
  | { type: ActionType.SET_FORM_LOADING; formLoading: State['formLoading'] }
  | { type: ActionType.SET_ADD_CARD_LOADING; addCardLoading: State['addCardLoading'] }
  | { type: ActionType.SET_EXPANDED; expanded: CheckoutTabs }
  | { type: ActionType.SET_LOAD_STRIPE_FORM; loadStripeForm: State['loadStripeForm'] }
  | { type: ActionType.SET_SELECTED_CARD; selectedCard: State['selectedCard'] }
  | { type: ActionType.SET_PAYMENT_TYPE; paymentType: State['paymentType'] };

export const checkoutFormReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.SET_FORM_LOADING:
      return { ...state, formLoading: action.formLoading };

    case ActionType.SET_ADD_CARD_LOADING:
      return { ...state, addCardLoading: action.addCardLoading };

    case ActionType.SET_EXPANDED:
      return { ...state, expanded: action.expanded };

    case ActionType.SET_LOAD_STRIPE_FORM:
      return { ...state, loadStripeForm: action.loadStripeForm };

    case ActionType.SET_SELECTED_CARD:
      return { ...state, selectedCard: action.selectedCard };

    case ActionType.SET_PAYMENT_TYPE:
      return { ...state, paymentType: action.paymentType };
  }
};
